import Button, {ButtonProps} from "@mui/material/Button"
import React from "react"

// Secondary action button (e.g. Back): Navy outline, sits directly beside the
// primary button. Never a tiny floating text link (brief G3). Colour, rounded
// shape, no-caps and 48px min-height come from the theme.
export const AppSecondaryButton: React.FC<ButtonProps> = (
  props: ButtonProps
) => {
  return <Button variant="outlined" color="secondary" {...props} />
}

export default AppSecondaryButton
